export const isMobileDevice = () => {
  return window.innerWidth <= 768 ||
         /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
};

export const isTouchDevice = () => {
  return 'ontouchstart' in window || navigator.maxTouchPoints > 0;
};

export const getDeviceType = () => {
  if (isMobileDevice()) {
    return 'mobile';
  }
  return 'desktop';
};

export const getScreenSize = () => {
  const width = window.innerWidth;
  if (width <= 480) return 'small';
  if (width <= 768) return 'medium';
  if (width <= 1024) return 'large';
  return 'xlarge';
};
